import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { resetToken } from '../../reducetool/features/authSlice';
import { allRemoveItem } from '../../reducetool/features/cardSlice';
import GiftInfoModal from './GiftInfoModal';
import RewardCardStatsModal from './RewardCardStatsModal';

const Gifts = () => { 
    const navigate = useNavigate();
    const authData = useSelector(state => state.authState);
    const [userDetail, setUserDetail] = useState(authData.user);
    const [isViewGift, setIsViewGift] = useState(false);
    const [isViewRewardCardStat, setIsViewRewardCardStat] = useState(false);
    
    const onHanldeGiftInfo = () => {
        setIsViewGift(true);
        //document.body.classList.add("modal-open-blur");
    }

    const handleGiftClose = () => {
        setIsViewGift(false);
        //document.body.classList.remove("modal-open-blur");
    }
    const onHanldeRewardCardStats = () => {
        setIsViewRewardCardStat(true);
        //document.body.classList.add("modal-open-blur");
    }
    const onhandleRewardCardStatsClose = () => {
        setIsViewRewardCardStat(false);
        //document.body.classList.remove("modal-open-blur");
    }


    return(
        <>
            <section className="user-dashboard-section section-b-space">
                    <div className="container-fluid-lg">
                        <div className="row">
                            <div className="col-xxl-12 col-lg-12">  
                            <div className="dashboard-card">
                                            <div className="title title-flex">
                                                <div>
                                                    <h2>Exciting Gifts by Valorelle</h2>
                                                    <span className="title-leaf">
                                                        <svg className="icon-width bg-gray">
                                                            <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="row g-4">

                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                                    <div className="seller-grid-box seller-grid-box-1 shadow-lg mb-0">

                                                        <div className="grid-image">

                                                            <div className="image">
                                                                <img
                                                                    src="../assets/images/level/rupee.png"
                                                                    className="img-fluid"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="contain-name">
                                                                <div>
                                                                    <h3>100% Cashback
                                                                        <span className='float-end'> <h5>X 9 times </h5></span>
                                                                    </h3>

                                                                    <div className="since-number">

                                                                        <h5>Get 100% full cashback upto Rs 10,000 for every order placed by you</h5>

                                                                    </div>
                                                                    {/* <label style={{ backgroundColor: "rgb(164 13 13 / 10%)", color: "#ff4f4f" }} className="product-label mt-2">1500 Shiv Coins Remaining</label> */}
                                                                    <label className="product-label mt-2">On Completing Level 7</label>

                                                                </div>

                                                            </div>
                                                        </div>
                                                        <button className='btn btn-md bg-theme cart-button text-white w-100 mb-2' onClick={onHanldeGiftInfo}>Know when will you be eligible </button>
                                                        <button className='btn btn-md bg-danger cart-button text-white w-100 mb-2' onClick={onHanldeRewardCardStats}>See your reward cards status</button>

                                                    </div>
                                                </div>

                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                                    <div className="seller-grid-box seller-grid-box-1 shadow-lg mb-0">

                                                        <div className="grid-image">

                                                            <div className="image">
                                                                <img
                                                                    src="../assets/images/level/insurance.png"
                                                                    className="img-fluid"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="contain-name">
                                                                <div>
                                                                    <h3>Insurance worth Rs 50,000
                                                                        <span className='float-end'> <h5>X 9 times </h5></span>
                                                                    </h3>

                                                                    <div className="since-number">

                                                                        <h5>Get 100% full cashback upto Rs 10,000 for every order placed by you</h5>

                                                                    </div>
                                                                    {/* <label style={{ backgroundColor: "rgb(164 13 13 / 10%)", color: "#ff4f4f" }} className="product-label mt-2">1500 Shiv Coins Remaining</label> */}
                                                                    <label className="product-label mt-2">On Completing Level 7</label>

                                                                </div>

                                                            </div>
                                                        </div>
                                                        <button className='btn btn-md bg-theme cart-button text-white w-100 mb-2' onClick={onHanldeGiftInfo}>Know when will you be eligible </button>
                                                        <button className='btn btn-md bg-danger cart-button text-white w-100 mb-2' onClick={onHanldeRewardCardStats}>See your reward cards status</button>

                                                    </div>
                                                </div>

                                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                                    <div className="seller-grid-box seller-grid-box-1 shadow-lg mb-0">

                                                        <div className="grid-image">

                                                            <div className="image">
                                                                <img
                                                                    src="../assets/images/level/mediclaim.png"
                                                                    className="img-fluid"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="contain-name">
                                                                <div>
                                                                    <h3>Mediclaim worth Rs 1,00,000
                                                                        <span className='float-end'> <h5>X 9 times </h5></span>
                                                                    </h3>

                                                                    <div className="since-number">

                                                                        <h5>Get 100% full cashback upto Rs 10,000 for every order placed by you</h5>

                                                                    </div>
                                                                    {/* <label style={{ backgroundColor: "rgb(164 13 13 / 10%)", color: "#ff4f4f" }} className="product-label mt-2">1500 Shiv Coins Remaining</label> */}
                                                                    <label className="product-label mt-2">On Completing Level 7</label>

                                                                </div>

                                                            </div>
                                                        </div>
                                                        <button className='btn btn-md bg-theme cart-button text-white w-100 mb-2' onClick={onHanldeGiftInfo}>Know when will you be eligible </button>
                                                        <button className='btn btn-md bg-danger cart-button text-white w-100 mb-2' onClick={onHanldeRewardCardStats}>See your reward cards status</button>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                            </div> 
                        </div>
                    </div>
            </section>

            {isViewGift &&
                <GiftInfoModal
                    handleGiftClose={handleGiftClose} />
            }


{isViewRewardCardStat &&
                <RewardCardStatsModal
                    handleRewardCardStatsClose={onhandleRewardCardStatsClose} />
            }
        </>)
}

export default Gifts;